<template lang="pug">
    div
        span(v-if="servername") {{servername}}
        a(
            v-clipboard:copy="servername"
            v-clipboard:success="onCheck"
            v-clipboard:error="onError"
        )  
            | {{'Check CNAME'}}
</template>
<script>
import { _checkCname } from "@/api/validate";

export default {
    name: "checkCname",
    props: ["servername"],
    components: {},
    watch: {},
    created() {},
    data() {
        return {};
    },
    methods: {
        async onCheck(e) {
            let res = await _checkCname({
                groupName: this.$store.state.queryGroupName == "all" ? "*" : this.$store.state.queryGroupName,
                servername: this.servername,
            });
            if (res.data.success) {
                this.$Message.success(res.data.message);
            } else {
                this.$Message.error(res.data.message);
            }
        },
        onError(e) {},
    },
    mounted() {},
    computed: {},
};
</script>



// WEBPACK FOOTER //
// src/components/checkCname.vue